<template>
  <fragment>
    <v-card max-width="320" class="mx-auto" height="100%">
      <v-card-text class="py-8" style="min-height: 290px;">
        <div class="text-center brand-product-icon mb-10 mx-auto">
          <v-icon size="54" color="warning">
            {{ ICONS[product.brandProductGroupId].icon }}
          </v-icon>
        </div>
        <p class="title font-weight-medium text-center primary--text text--darken-3">
          {{ $t(product.productGroupTitle) }}
        </p>
        <p class="caption text-center">
          {{ $t(product.productGroupDesc) }}
        </p>
      </v-card-text>
      <!--v-divider />
      <v-card-actions class="px-4">
        <div class="body-2">
          Részletek megtekintése
        </div>
        <v-spacer />
        <v-icon color="warning" @click="detailsDialogIsVisible = true">
          mdi-plus
        </v-icon>
      </v-card-actions-->
    </v-card>
    <!--v-dialog v-model="detailsDialogIsVisible" max-width="1024">
      <v-card>
        <v-card-title class="warning">
          Részletek - {{ product.productGroupTitle }}
        </v-card-title>
        <v-card-text>
        </v-card-text>
      </v-card>
    </v-dialog-->
  </fragment>
</template>

<script>
import { PRODUCT_GROUP_ICONS } from '../plugins/appConst';

export default {
  name: 'availableProductCard',
  props: {
    product: Object,
  },
  data() {
    return {
      ICONS: PRODUCT_GROUP_ICONS,
      detailsDialogIsVisible: false,
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
